/* eslint-disable camelcase */
class MassiveDownloadJob {
  constructor ({ id, filename, status, b_status, name, created_at, finished_at, base_dir, surname }) {
    this.id = id
    this.filename = filename
    this.status = status
    this.bStatus = b_status
    this.name = name
    this.createdAt = created_at
    this.finishedAt = finished_at
    this.baseDir = base_dir
    this.surname = surname || ''
  }

  get fullname () {
    return `${this.name} ${this.surname} `
  }
}

export default MassiveDownloadJob



// WEBPACK FOOTER //
// ./src/app/massive_download/models/MassiveDownloadJob.js